export default __webpack_public_path__ + "static/media/38-min.d1f3f0ed.png";